/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploader_RemoveInputs */

const en_common_uploader_remove = /** @type {(inputs: Common_Uploader_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove image`)
};

const zh_common_uploader_remove = /** @type {(inputs: Common_Uploader_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除图片`)
};

/**
* | output |
* | --- |
* | "Remove image" |
*
* @param {Common_Uploader_RemoveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_remove = /** @type {((inputs?: Common_Uploader_RemoveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_RemoveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_remove(inputs)
	return zh_common_uploader_remove(inputs)
});
export { common_uploader_remove as "common.uploader.remove" }